import { render, staticRenderFns } from "./ui-tab.vue?vue&type=template&id=181a08ac"
import script from "./ui-tab.vue?vue&type=script&lang=js"
export * from "./ui-tab.vue?vue&type=script&lang=js"
import style0 from "./ui-tab.vue?vue&type=style&index=0&id=181a08ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports